import { createFileRoute, redirect } from '@tanstack/react-router';
import { AcceptClientRoute } from '@/pages/AcceptClientPage/AcceptClientPage.tsx';
import { getClient } from '@/pages/ClientsTab/api/clients.api.ts';
import { LINK_STATUS } from '@/pages/ClientsTab/types.ts';
import { getAccountantExternalId } from '@/contexts/accountantExternalId.ts';

export const Route = createFileRoute('/clients/$clientExternalId/accept')({
  component: AcceptClientRoute,
  loader: async ({ context, params }) => {
    const accountantExternalId = getAccountantExternalId();
    if (!accountantExternalId) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/clients' });
    }

    const client = await getClient(
      context.queryClient,
      accountantExternalId,
      params.clientExternalId
    );

    if (client?.linkStatus !== LINK_STATUS.PENDING_TERMS_ACCEPTANCE) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/clients' });
    }

    return { businessName: client.businessName, linkExternalId: client.linkExternalId };
  },
});
